export enum PopupWindowID {
  AGREEMENT = "agreement",
  ANSWER_CHOISE = "answer-choise",
  VALIDATION = "validation",
  SIGN_UP = "sign-up",
  BONUSES = "bonuses",
  FINAL_FORM = "final-form",
  WHATSAPP_INSTRUCTIONS = "whatsapp_instructions"
}